/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    a: "a",
    pre: "pre",
    code: "code",
    blockquote: "blockquote",
    h3: "h3"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "React Native(React Native)"
    }), "\n", _jsxs(_components.p, {
      children: ["styled-components 可以以相同的方式和相同的导入与 React Native 一起使用。使用 ", _jsx(_components.a, {
        href: "https://snack.expo.io/@danielmschmidt/styled-components",
        children: "Expo 小样"
      }), " 尝试此示例。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥styled-components can be used with React Native in the same way and with the\nsame import. Try this example with ", _jsx(_components.a, {
        href: "https://snack.expo.io/@danielmschmidt/styled-components",
        children: "Snack by Expo"
      }), "."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import React from 'react'\nimport styled from 'styled-components/native'\n\nconst StyledView = styled.View`\n  background-color: papayawhip;\n`\n\nconst StyledText = styled.Text`\n  color: #BF4F74;\n`\n\nclass MyReactNativeComponent extends React.Component {\n  render() {\n    return (\n      <StyledView>\n        <StyledText>Hello World!</StyledText>\n      </StyledView>\n    )\n  }\n}\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["我们还支持更复杂的样式（例如 ", _jsx(_components.code, {
        children: "transform"
      }), "）（通常是一个数组）和简写（例如 ", _jsx(_components.code, {
        children: "margin"
      }), "），这要归功于 ", _jsx(_components.a, {
        href: "https://github.com/styled-components/css-to-react-native",
        children: _jsx(_components.code, {
          children: "css-to-react-native"
        })
      }), "！"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥We also support more complex styles (like ", _jsx(_components.code, {
        children: "transform"
      }), "), which would normally\nbe an array, and shorthands (e.g. for ", _jsx(_components.code, {
        children: "margin"
      }), ") thanks to\n", _jsx(_components.a, {
        href: "https://github.com/styled-components/css-to-react-native",
        children: _jsx(_components.code, {
          children: "css-to-react-native"
        })
      }), "!"]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["请注意，", _jsx(_components.code, {
          children: "flex"
        }), " 属性的工作方式类似于 CSS 速记，而不是 React Native 中旧版的 ", _jsx(_components.code, {
          children: "flex"
        }), " 属性。除了将 ", _jsx(_components.code, {
          children: "flexGrow"
        }), " 设置为 ", _jsx(_components.code, {
          children: "1"
        }), " 和 ", _jsx(_components.code, {
          children: "flexBasis"
        }), " 为 ", _jsx(_components.code, {
          children: "0"
        }), " 之外，设置 ", _jsx(_components.code, {
          children: "flex: 1"
        }), " 还会将 ", _jsx(_components.code, {
          children: "flexShrink"
        }), " 设置为 ", _jsx(_components.code, {
          children: "1"
        }), "。"]
      }), "\n", _jsxs(_components.p, {
        children: ["¥Note that the ", _jsx(_components.code, {
          children: "flex"
        }), " property works like CSS shorthand, and not the legacy\n", _jsx(_components.code, {
          children: "flex"
        }), " property in React Native. Setting ", _jsx(_components.code, {
          children: "flex: 1"
        }), " sets ", _jsx(_components.code, {
          children: "flexShrink"
        }), "\nto ", _jsx(_components.code, {
          children: "1"
        }), " in addition to setting ", _jsx(_components.code, {
          children: "flexGrow"
        }), " to ", _jsx(_components.code, {
          children: "1"
        }), " and ", _jsx(_components.code, {
          children: "flexBasis"
        }), " to ", _jsx(_components.code, {
          children: "0"
        }), "."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "想象一下你如何在 React Native 中编写该属性，猜猜你如何将其传输到 CSS，你可能是对的："
    }), "\n", _jsx(_components.p, {
      children: "¥Imagine how you'd write the property in React Native, guess how you'd transfer\nit to CSS, and you're probably right:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "const RotatedBox = styled.View`\n  transform: rotate(90deg);\n  text-shadow-offset: 10px 5px;\n  font-variant: small-caps;\n  margin: 5px 7px 2px;\n`\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["与网络版本的一些区别是，你不能使用 ", _jsx(_components.code, {
        children: "keyframes"
      }), " 和 ", _jsx(_components.code, {
        children: "createGlobalStyle"
      }), " 辅助程序，因为 React Native 不支持关键帧或全局样式。如果你使用媒体查询或嵌套 CSS，我们还会向你触发警告。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Some of the differences to the web-version are, that you cannot use the\n", _jsx(_components.code, {
        children: "keyframes"
      }), " and ", _jsx(_components.code, {
        children: "createGlobalStyle"
      }), " helpers since React Native doesn't support\nkeyframes or global styles. We will also warn you if you use media queries or\nnest your CSS."]
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsxs(_components.p, {
        children: ["在 v2 中我们支持百分比。为了实现这一点，我们需要强制所有速记单位。如果你要迁移到 v2，则 ", _jsx(_components.a, {
          href: "https://github.com/styled-components/styled-components-native-code-mod",
          children: "有可用的代码模式"
        }), "。"]
      }), "\n", _jsxs(_components.p, {
        children: ["¥In v2 we support percentages. To make this possible we need to enforce units\nfor all shorthands. If you're migrating to v2,\n", _jsx(_components.a, {
          href: "https://github.com/styled-components/styled-components-native-code-mod",
          children: "a codemod is available"
        }), "."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Metro 打包器的使用更简单(Simpler usage with the metro bundler)"
    }), "\n", _jsx(_components.p, {
      children: "¥Simpler usage with the metro bundler"
    }), "\n", _jsxs(_components.p, {
      children: ["如果你希望仅导入 ", _jsx(_components.code, {
        children: "styled-components"
      }), " 而不是 ", _jsx(_components.code, {
        children: "styled-components/native"
      }), "，则可以添加包含 ", _jsx(_components.code, {
        children: "\"react-native\""
      }), " 的 ", _jsxs(_components.a, {
        href: "https://facebook.github.io/metro/docs/configuration#resolvermainfields",
        children: [_jsx(_components.code, {
          children: "resolverMainFields"
        }), " 配置"]
      }), "。这曾经在 Metro 中默认受支持（目前在 haul 中有效），但似乎已在某个时候被删除。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If you'd prefer to just import ", _jsx(_components.code, {
        children: "styled-components"
      }), " instead of ", _jsx(_components.code, {
        children: "styled-components/native"
      }), ", you can add a ", _jsxs(_components.a, {
        href: "https://facebook.github.io/metro/docs/configuration#resolvermainfields",
        children: [_jsx(_components.code, {
          children: "resolverMainFields"
        }), " configuration"]
      }), " that includes ", _jsx(_components.code, {
        children: "\"react-native\""
      }), ". This used to be supported in metro by default (and currently does work in haul) but appears to have been removed at some point."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
